import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot } from "vue";
import { computed, watchEffect } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { usePrimeVue } from 'primevue/config';
import { getPrimevueTranslations } from 'common/vue/Data/Constants/primevue-translations';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ApplicationWrapper',
    setup: function (__props) {
        var locale = computed(function () { var _a, _b; return (_b = (_a = usePage()) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.locale; });
        var primeVue = usePrimeVue();
        watchEffect(function () {
            if (locale.value) {
                primeVue.config.locale = getPrimevueTranslations(locale.value);
            }
        });
        return function (_ctx, _cache) {
            return _renderSlot(_ctx.$slots, "default");
        };
    }
});
